import { makeObservable } from 'mobx';
import { ClientConfigurationModel, HospitalScheduleTemplateListingModel, IHospitalScheduleTemplateListingModel, IOrderByParams } from '@common/models';
import { StandardSearchStore } from '@common/stores';
import { SearchService } from '@common/services/searchService';

const defaultScheduleTemplateSearchOrder: Array<IOrderByParams> = [
    {
        field: "name",
        dir: "asc"
    }
]
// var searchTerm = searchRequest.GetFilterValueAsString("searchTerm");
// var hospitalId = searchRequest.GetFilterValueAsInt("hospitalId");
// var isActive = searchRequest.GetFilterValueAsBool("isActive");
// var isDefault = searchRequest.GetFilterValueAsBool("isDefault");
export interface IHospitalScheduleTemplatSearchFilter {
    searchTerm?: string,
    hospitalId?: number,
    isActive?: boolean,
    isDefault?: boolean
}

const defaultHospitalScheduleTemplateSearchFilter: IHospitalScheduleTemplatSearchFilter = {
    searchTerm: undefined,
    hospitalId: undefined,
    isActive: undefined,
    isDefault: undefined
}

export class HospitalScheduleTemplateSearchStore extends StandardSearchStore<IHospitalScheduleTemplatSearchFilter, IHospitalScheduleTemplateListingModel, HospitalScheduleTemplateListingModel> {

    constructor(configuration: ClientConfigurationModel, defaultSearchFilterOverrides?: Partial<IHospitalScheduleTemplatSearchFilter>) {
        super({
            endpointUrl: SearchService.SearchEndPoints.hospitalScheduleTemplates,
            defaultSearchParams: {
                orderby: defaultScheduleTemplateSearchOrder, top: 10
            },
            defaultSearchFilter: {
                ...defaultHospitalScheduleTemplateSearchFilter,
                ...defaultSearchFilterOverrides
            },
        }, (result: IHospitalScheduleTemplateListingModel) => new HospitalScheduleTemplateListingModel(result));
        makeObservable(this, undefined);
    }
}
